(function () {
  if (!window.PGdataLayer) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  function clearStuckOverlays() {
    var pc = document.getElementById('onetrust-pc-sdk');
    var filter = document.querySelector('#onetrust-consent-sdk .onetrust-pc-dark-filter');
    var pcHidden =
      !pc ||
      pc.classList.contains('ot-hide') ||
      pc.getAttribute('aria-hidden') === 'true' ||
      window.getComputedStyle(pc).display === 'none';

    if (pcHidden) {
      if (pc) {
        pc.style.setProperty('display', 'none', 'important');
        pc.style.setProperty('visibility', 'hidden', 'important');
        pc.style.setProperty('pointer-events', 'none', 'important');
      }
      if (filter) {
        filter.style.setProperty('display', 'none', 'important');
        filter.style.setProperty('opacity', '0', 'important');
        filter.style.setProperty('visibility', 'hidden', 'important');
        filter.style.setProperty('pointer-events', 'none', 'important');
      }
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    }

    var pageTransition = document.getElementById('page-transition-overlay');
    if (pageTransition && pageTransition.classList.contains('active')) {
      pageTransition.className = '';
    }
  }

  function bindOneTrustCleanup() {
    document.addEventListener(
      'click',
      function (evt) {
        var closeControl =
          evt.target.closest &&
          evt.target.closest(
            [
              '#close-pc-btn-handler',
              '#onetrust-pc-sdk .ot-close-icon',
              '#onetrust-pc-sdk .save-preference-btn-handler',
              '#onetrust-pc-sdk .ot-pc-refuse-all-handler',
              '#accept-recommended-btn-handler',
              '#onetrust-pc-sdk button[aria-label="Close"]'
            ].join(', ')
          );

        if (!closeControl) {
          return;
        }

        window.setTimeout(clearStuckOverlays, 100);
        window.setTimeout(clearStuckOverlays, 400);
        window.setTimeout(clearStuckOverlays, 1000);
      },
      true
    );

    window.addEventListener('OTConsentApplied', clearStuckOverlays);
    window.addEventListener('OneTrustGroupsUpdated', clearStuckOverlays);

    if (typeof MutationObserver === 'undefined') {
      return;
    }

    var observePc = function () {
      var pc = document.getElementById('onetrust-pc-sdk');
      if (!pc || pc.getAttribute('data-pg-ot-observed')) {
        return;
      }

      pc.setAttribute('data-pg-ot-observed', 'true');
      new MutationObserver(function () {
        clearStuckOverlays();
      }).observe(pc, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
      });
    };

    observePc();
    new MutationObserver(observePc).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  bindOneTrustCleanup();

  function bindShopifyConsentBridge() {
    var bridge = {
      shopifyReady: false,
      activeGroupIds: [],
      // 'pg' = US model (CHD + Cookie PI); 'standard' = classic OneTrust categories (e.g. Canada)
      model: null,
      chdGroupId: null,
      cookiePiGroupId: null,
      analyticsGroupId: null,
      functionalGroupId: null,
      advertisingGroupId: null,
      analyticsAlwaysActive: false,
      functionalAlwaysActive: false,
      advertisingAlwaysActive: false,
      groupsResolved: false,
      resolutionError: null,
      lastPayloadKey: null,
      syncQueued: false,
      onConsentChangedBound: false,
      hasUserDecision: false
    };

    function setBridgeError(message) {
      var repeat = bridge.resolutionError === message;
      bridge.resolutionError = message;
      window.PGdataLayer.consentBridgeError = message;
      if (!repeat) {
        console.error('[PGdataLayer] OneTrust→Shopify consent bridge:', message);
      }
    }

    function clearBridgeError() {
      bridge.resolutionError = null;
      if (window.PGdataLayer.consentBridgeError) {
        delete window.PGdataLayer.consentBridgeError;
      }
    }

    function normalizeName(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function parseActiveGroupIds(source) {
      if (Array.isArray(source)) {
        return source
          .map(function (id) {
            return String(id || '').trim();
          })
          .filter(Boolean);
      }

      if (typeof source === 'string') {
        return source
          .split(',')
          .map(function (id) {
            return id.trim();
          })
          .filter(Boolean);
      }

      return [];
    }

    function readActiveGroupsFromCookie() {
      var match = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]*)/);
      if (!match) {
        return [];
      }

      try {
        var decoded = decodeURIComponent(match[1]);
        var groupsMatch = decoded.match(/(?:^|&)groups=([^&]*)/);
        if (!groupsMatch) {
          return [];
        }

        var raw = decodeURIComponent(groupsMatch[1]);
        var active = [];

        raw.split(',').forEach(function (pair) {
          var parts = pair.split(':');
          if (parts.length < 2) {
            return;
          }

          var id = String(parts[0] || '').trim();
          var allowed = String(parts[1] || '').trim() === '1';
          if (id && allowed) {
            active.push(id);
          }
        });

        return active;
      } catch (err) {
        return [];
      }
    }

    function updateActiveGroupIds(detail) {
      var next = parseActiveGroupIds(detail);
      if (!next.length && typeof window.OnetrustActiveGroups === 'string') {
        next = parseActiveGroupIds(window.OnetrustActiveGroups);
      }
      if (!next.length) {
        next = readActiveGroupsFromCookie();
      }

      bridge.activeGroupIds = next;
      return next;
    }

    function isAlwaysActiveGroup(group) {
      if (!group) {
        return false;
      }

      if (group.IsAlwaysActive === true || group.AlwaysActive === true) {
        return true;
      }

      var status = normalizeName(group.Status || group.GroupStatus || '');
      return status === 'always' || status === 'always active' || status === 'activealways';
    }

    function getDomainGroups() {
      if (!window.OneTrust || typeof window.OneTrust.GetDomainData !== 'function') {
        return [];
      }

      try {
        var domainData = window.OneTrust.GetDomainData();
        if (!domainData) {
          return [];
        }

        if (Array.isArray(domainData.Groups)) {
          return domainData.Groups;
        }

        if (domainData.DomainData && Array.isArray(domainData.DomainData.Groups)) {
          return domainData.DomainData.Groups;
        }
      } catch (err) {
        setBridgeError('GetDomainData() failed: ' + (err && err.message ? err.message : err));
      }

      return [];
    }

    function findGroupByTerms(groups, terms, preferFirstTerm) {
      var matches = [];
      var preferred = [];

      groups.forEach(function (group) {
        var name = normalizeName(group.GroupName || group.Name || '');
        if (!name) {
          return;
        }

        var hitIndex = -1;
        for (var i = 0; i < terms.length; i += 1) {
          if (name.indexOf(terms[i]) !== -1) {
            hitIndex = i;
            break;
          }
        }

        if (hitIndex === -1) {
          return;
        }

        matches.push(group);
        if (preferFirstTerm && hitIndex === 0) {
          preferred.push(group);
        }
      });

      if (preferFirstTerm && preferred.length) {
        return preferred;
      }

      return matches;
    }

    function resolveGroupId(groups, terms, label, preferFirstTerm) {
      var matches = findGroupByTerms(groups, terms, !!preferFirstTerm);

      if (!matches.length) {
        return { error: label + ' group not found by name' };
      }

      if (matches.length > 1) {
        return { error: label + ' group name matched multiple groups' };
      }

      var group = matches[0];
      if (isAlwaysActiveGroup(group)) {
        return { error: label + ' group is Always Active and cannot report denial' };
      }

      var id = String(group.OptanonGroupId || group.CustomGroupId || group.GroupId || '').trim();
      if (!id) {
        return { error: label + ' group has no usable ID' };
      }

      return { id: id, group: group };
    }

    function resolveStandardGroup(groups, standardId, terms, label) {
      // Standard OneTrust categories keep stable C000x IDs across languages,
      // so prefer the ID and fall back to en/fr name terms.
      // Unlike the P&G custom groups, an Always Active category here is a valid
      // configuration (e.g. CA marks Analytics as Always Active): consent for it
      // is permanently granted, so resolve it and let the active-group list
      // report it as allowed.
      var byId = null;

      groups.forEach(function (group) {
        var id = String(group.OptanonGroupId || group.CustomGroupId || group.GroupId || '').trim();
        if (id === standardId) {
          byId = group;
        }
      });

      if (byId) {
        return { id: standardId, group: byId, alwaysActive: isAlwaysActiveGroup(byId) };
      }

      var matches = findGroupByTerms(groups, terms, false);
      if (!matches.length) {
        return { error: label + ' group not found by name' };
      }
      if (matches.length > 1) {
        return { error: label + ' group name matched multiple groups' };
      }

      var group = matches[0];
      var id = String(group.OptanonGroupId || group.CustomGroupId || group.GroupId || '').trim();
      if (!id) {
        return { error: label + ' group has no usable ID' };
      }

      return { id: id, group: group, alwaysActive: isAlwaysActiveGroup(group) };
    }

    function distinctIds() {
      var seen = {};
      for (var i = 0; i < arguments.length; i += 1) {
        if (seen[arguments[i]]) {
          return false;
        }
        seen[arguments[i]] = true;
      }
      return true;
    }

    function resolveConsentGroups() {
      var groups = getDomainGroups();
      if (!groups.length) {
        bridge.groupsResolved = false;
        bridge.model = null;
        return false;
      }

      // Model 1: P&G US preference center (CHD + Cookie PI custom groups).
      var chd = resolveGroupId(groups, ['consumer health data'], 'Consumer Health Data');
      var cookiePi = resolveGroupId(
        groups,
        ['cookie pi', 'tracking technologies'],
        'Cookie PI',
        true
      );

      if (!chd.error && !cookiePi.error && chd.id !== cookiePi.id) {
        bridge.model = 'pg';
        bridge.chdGroupId = chd.id;
        bridge.cookiePiGroupId = cookiePi.id;
        bridge.groupsResolved = true;
        window.PGdataLayer.consentModel = 'pg';
        clearBridgeError();
        return true;
      }

      // Model 2: standard OneTrust categories (e.g. Canada preference center:
      // Analytics / Functional / Advertising / Social Media Cookies).
      var analytics = resolveStandardGroup(
        groups,
        'C0002',
        ['analytics', 'performance', 'analyse'],
        'Analytics'
      );
      var functional = resolveStandardGroup(
        groups,
        'C0003',
        ['functional', 'fonctionnel'],
        'Functional'
      );
      var advertising = resolveStandardGroup(
        groups,
        'C0004',
        ['advertising', 'targeting', 'publicit', 'ciblage'],
        'Advertising'
      );

      if (
        !analytics.error &&
        !functional.error &&
        !advertising.error &&
        distinctIds(analytics.id, functional.id, advertising.id)
      ) {
        bridge.model = 'standard';
        bridge.analyticsGroupId = analytics.id;
        bridge.functionalGroupId = functional.id;
        bridge.advertisingGroupId = advertising.id;
        bridge.analyticsAlwaysActive = !!analytics.alwaysActive;
        bridge.functionalAlwaysActive = !!functional.alwaysActive;
        bridge.advertisingAlwaysActive = !!advertising.alwaysActive;
        bridge.groupsResolved = true;
        window.PGdataLayer.consentModel = 'standard';
        clearBridgeError();
        return true;
      }

      bridge.groupsResolved = false;
      bridge.model = null;

      var pgErrors = [chd.error, cookiePi.error].filter(Boolean).join('; ');
      var stdErrors = [analytics.error, functional.error, advertising.error]
        .filter(Boolean)
        .join('; ');
      setBridgeError(
        'No consent model resolved. PG model: [' +
          (pgErrors || 'ambiguous IDs') +
          '] Standard model: [' +
          (stdErrors || 'ambiguous IDs') +
          ']'
      );
      return false;
    }

    function isGroupAllowed(groupId) {
      if (!groupId) {
        return false;
      }

      return bridge.activeGroupIds.indexOf(groupId) !== -1;
    }

    function buildConsentPayload() {
      if (bridge.groupsResolved && bridge.model === 'pg') {
        var healthDataAllowed = isGroupAllowed(bridge.chdGroupId);
        var cookiePiAllowed = isGroupAllowed(bridge.cookiePiGroupId);

        return {
          analytics: healthDataAllowed,
          preferences: healthDataAllowed,
          marketing: healthDataAllowed && cookiePiAllowed,
          sale_of_data: cookiePiAllowed
        };
      }

      if (bridge.groupsResolved && bridge.model === 'standard') {
        var advertisingAllowed =
          bridge.advertisingAlwaysActive || isGroupAllowed(bridge.advertisingGroupId);

        return {
          analytics: bridge.analyticsAlwaysActive || isGroupAllowed(bridge.analyticsGroupId),
          preferences: bridge.functionalAlwaysActive || isGroupAllowed(bridge.functionalGroupId),
          marketing: advertisingAllowed,
          sale_of_data: advertisingAllowed
        };
      }

      if (bridge.hasUserDecision) {
        // Fail closed: decision exists but no model resolved → deny everything.
        return {
          analytics: false,
          preferences: false,
          marketing: false,
          sale_of_data: false
        };
      }

      return null;
    }

    function payloadKey(payload) {
      return [
        payload.analytics ? '1' : '0',
        payload.preferences ? '1' : '0',
        payload.marketing ? '1' : '0',
        payload.sale_of_data ? '1' : '0'
      ].join('');
    }

    function hasValidStoredConsent() {
      return !!(
        window.OneTrust &&
        typeof window.OneTrust.IsAlertBoxClosedAndValid === 'function' &&
        window.OneTrust.IsAlertBoxClosedAndValid()
      );
    }

    function writeConsentToShopify(reason) {
      if (!bridge.shopifyReady || !window.Shopify || !window.Shopify.customerPrivacy) {
        bridge.syncQueued = true;
        return;
      }

      if (hasValidStoredConsent()) {
        bridge.hasUserDecision = true;
      }

      if (!bridge.hasUserDecision) {
        return;
      }

      if (!bridge.groupsResolved) {
        resolveConsentGroups();
      }

      if (!bridge.groupsResolved) {
        setBridgeError(
          bridge.resolutionError ||
            'Consent decision present but OneTrust groups could not be resolved; writing denied payload'
        );
      }

      var payload = buildConsentPayload();
      if (!payload) {
        return;
      }

      var key = payloadKey(payload);
      if (key === bridge.lastPayloadKey) {
        return;
      }

      bridge.syncQueued = false;

      try {
        window.Shopify.customerPrivacy.setTrackingConsent(payload, function (data) {
          if (data && data.error) {
            console.error(
              '[PGdataLayer] setTrackingConsent failed (' + reason + '):',
              data.error
            );
            // Keep lastPayloadKey unset so a later valid change can retry.
            return;
          }

          bridge.lastPayloadKey = key;
          window.PGdataLayer.shopifyConsent = payload;
        });
      } catch (err) {
        console.error(
          '[PGdataLayer] setTrackingConsent threw (' + reason + '):',
          err && err.message ? err.message : err
        );
      }
    }

    function onGroupsUpdated(evt) {
      updateActiveGroupIds(evt && evt.detail);
      resolveConsentGroups();
      bindOnConsentChanged();

      // GroupsUpdated never implies a new user decision by itself. It may:
      // 1) finish a queued write after a prior decision, or
      // 2) unlock stored-consent reconcile once OneTrust domain data is available.
      if (bridge.syncQueued && (bridge.hasUserDecision || hasValidStoredConsent())) {
        writeConsentToShopify('queued-after-groups-updated');
        return;
      }

      if (!bridge.lastPayloadKey && hasValidStoredConsent()) {
        bridge.hasUserDecision = true;
        writeConsentToShopify('stored-consent-after-groups-updated');
      }
    }

    function onConsentDecision(reason) {
      bridge.hasUserDecision = true;
      updateActiveGroupIds(
        typeof window.OnetrustActiveGroups === 'string' ? window.OnetrustActiveGroups : []
      );
      resolveConsentGroups();
      writeConsentToShopify(reason);
    }

    function bindOnConsentChanged() {
      if (bridge.onConsentChangedBound) {
        return;
      }

      if (!window.OneTrust || typeof window.OneTrust.OnConsentChanged !== 'function') {
        return;
      }

      bridge.onConsentChangedBound = true;
      window.OneTrust.OnConsentChanged(function () {
        onConsentDecision('OnConsentChanged');
      });
    }

    function tryReconcileStoredConsent() {
      bindOnConsentChanged();

      if (!hasValidStoredConsent()) {
        return;
      }

      bridge.hasUserDecision = true;
      updateActiveGroupIds(
        typeof window.OnetrustActiveGroups === 'string' ? window.OnetrustActiveGroups : []
      );
      resolveConsentGroups();
      writeConsentToShopify('stored-consent-reconcile');
    }

    function waitForOneTrust(attempt) {
      bindOnConsentChanged();
      resolveConsentGroups();

      if (hasValidStoredConsent()) {
        tryReconcileStoredConsent();
        return;
      }

      if (window.OneTrust) {
        return;
      }

      if (attempt > 40) {
        return;
      }

      window.setTimeout(function () {
        waitForOneTrust(attempt + 1);
      }, 250);
    }

    window.addEventListener('OneTrustGroupsUpdated', onGroupsUpdated);
    window.addEventListener('OTConsentApplied', function () {
      onConsentDecision('OTConsentApplied');
    });

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1'
          }
        ],
        function (error) {
          if (error) {
            console.error('[PGdataLayer] Failed to load consent-tracking-api:', error);
            return;
          }

          bridge.shopifyReady = true;
          if (bridge.syncQueued || bridge.hasUserDecision || hasValidStoredConsent()) {
            writeConsentToShopify('shopify-api-ready');
          }
        }
      );
    } else {
      console.error('[PGdataLayer] Shopify.loadFeatures unavailable; consent bridge idle');
    }

    waitForOneTrust(0);
  }

  bindShopifyConsentBridge();

  function getProductName() {
    if (window.PGdataLayer.product && window.PGdataLayer.product.name) {
      return window.PGdataLayer.product.name;
    }

    var titleEl = document.querySelector(
      '[data-product-title], .product__title, h1.product-title, .product-item__product-title'
    );
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function updateProductFromVariant(variant) {
    if (!variant || !window.PGdataLayer.product) {
      return;
    }

    window.PGdataLayer.product.gtin = variant.sku || '';
    window.PGdataLayer.product.upc = variant.barcode || '';
  }

  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    updateProductFromVariant(variant);
  });

  function getRetailerName(el) {
    if (!el) {
      return '';
    }

    var named =
      el.getAttribute('data-retailer-name') ||
      el.getAttribute('data-seller-name') ||
      el.getAttribute('aria-label') ||
      '';

    if (named) {
      return named.trim();
    }

    var sellerRoot = el.closest('[data-seller], .ps-online-seller, .ps-local-seller, .ps-seller');
    if (sellerRoot) {
      var img = sellerRoot.querySelector('img[alt]');
      if (img && img.alt) {
        return img.alt.trim();
      }

      var text = sellerRoot.textContent || '';
      text = text.replace(/\s+/g, ' ').trim();
      if (text) {
        return text.slice(0, 80);
      }
    }

    var imgAlt = el.querySelector && el.querySelector('img[alt]');
    if (imgAlt && imgAlt.alt) {
      return imgAlt.alt.trim();
    }

    return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
  }

  function isRetailerClickTarget(el) {
    if (!el || !el.closest) {
      return false;
    }

    return el.closest(
      [
        '[data-retailer-link]',
        '.ps-online-store-redirect-button',
        '.ps-local-store-redirect-button',
        '.ps-local-seller-button',
        '.ps-local-aggregate-seller-button',
        'a.ps-online-store-redirect-button',
        'a.ps-local-store-redirect-button'
      ].join(',')
    );
  }

  document.addEventListener(
    'click',
    function (evt) {
      var target = isRetailerClickTarget(evt.target);
      if (!target) {
        return;
      }

      var retailerName = getRetailerName(target);
      var productName = getProductName();

      window.dataLayer.push({
        event: 'event_buy_now',
        event_category: 'event_bin_action',
        event_action: 'event_buy_now',
        event_label: productName,
        retailer_name: retailerName
      });
    },
    true
  );
})();
